export const getReferralInfoFromCurrentUrl = () => {
    const referralInfo = new URLSearchParams(window.location.search).get('referralInfo');
    switch (referralInfo) {
        case 'app-templates':
            return 'Build CLI app from template - Start with App Builder';
        case 'cli-modal':
            return 'Build CLI app from scratch - Start with App Builder';
        case 'custom-apps-splash-page':
            return 'Custom Apps splash page - Build with AI';
        case 'custom-apps-dropdown':
            return 'Create New App dropdown - Build with AI';
        case 'custom-apps-empty-state':
            return 'Custom Apps Empty State - Build with AI';
        default:
            return undefined;
    }
};
export const getReferrerFromCurrentUrl = () => {
    const raw = new URLSearchParams(window.location.search).get('referrer') ??
        document.referrer;
    if (!raw) {
        return '';
    }
    const url = new URL(raw);
    return `${url.origin}${url.pathname}`;
};
//# sourceMappingURL=utils.js.map